import { render, staticRenderFns } from "./CustomRequest.vue?vue&type=template&id=56739404&scoped=true&"
import script from "./CustomRequest.vue?vue&type=script&lang=ts&"
export * from "./CustomRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56739404",
  null
  
)

export default component.exports